import { Service } from "@warda/library-ui/interfaces";
import { BASE_URL } from "../constants/keys";
import { addAccessCodeTokenToUrl } from "../components/AreaSharepage/accessCodeUtil/accessCodeUtil";
const apiUrlsSharePage = {
    login: {
        url: `/${Service.SHAREPAGE}/media/login`,
        method: "POST",
    },
    fileTypesSynoptic: {
        url: () => {
            const base = `/${Service.SHAREPAGE}/public-media/fileTypes/synoptic`;
            return addAccessCodeTokenToUrl(base);
        },
        method: "GET",
    },
    searchFiles: {
        url: () => {
            const base = `${BASE_URL}/${Service.SHAREPAGE}/library/public-page/public-files`;
            return addAccessCodeTokenToUrl(base);
        },
        method: "POST",
    },
    downloadMassive: {
        url: () => {
            const base = `${BASE_URL}/${Service.SHAREPAGE}/media/download-massive`;
            return addAccessCodeTokenToUrl(base);
        },
        method: "POST",
    },
    mediaDownload: {
        url: (fileId, rendition, downloadAs, redirect = true) => {
            const base = `${BASE_URL}/${Service.SHAREPAGE}/media/download-published/${fileId}?redirect=${redirect}`;
            return addAccessCodeTokenToUrl(base, {
                rendition,
                downloadAs,
            });
        },
        method: "GET",
    },
    mediaZoom: {
        url: ({ fileId, redirect = false, }) => {
            const base = `${BASE_URL}/${Service.SHAREPAGE}/media/download-published/${fileId}/zoom-tiles/tiles.dzi?redirect=${redirect}`;
            return addAccessCodeTokenToUrl(base);
        },
        method: "GET",
    },
    boxDocumentId: {
        url: (fileId) => {
            const base = `${BASE_URL}/${Service.SHAREPAGE}/media/download-published/${fileId}/published-documents`;
            return addAccessCodeTokenToUrl(base);
        },
        method: "GET",
    },
    boxDocumentToken: {
        url: (documentId) => {
            const base = `${BASE_URL}/${Service.SHAREPAGE}/media/download-published/document/${documentId}`;
            return addAccessCodeTokenToUrl(base);
        },
        method: "GET",
    },
};
export default apiUrlsSharePage;
